import { isStaticAlias } from "components/siteStructure/aliases/utils";
import filter from "lodash/filter";
import { IDomainState } from "models/domainStates";

export const selectAliases = (state: IDomainState) => state.aliases.aliases;

export const selectStaticAliases = (state: IDomainState) =>
  filter(state.aliases.aliases, isStaticAlias);
